// extracted by mini-css-extract-plugin
module.exports = {"input":"i_Jy","text":"i_Jz","label":"i_J0"};